import script from "./LevelReassignModal.vue?vue&type=script&setup=true&lang=js"
export * from "./LevelReassignModal.vue?vue&type=script&setup=true&lang=js"

import "./LevelReassignModal.vue?vue&type=style&index=0&id=db25a7e6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db25a7e6"]])

export default __exports__